import styled from "styled-components";
import { deviceQuery } from "../../../styles/mediaSizes"

export const PoolDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  height: 100%;
  border-radius: 10px;

  @media ${deviceQuery.mobileL} {
    padding: 0rem 1rem;
    .margin {
      margin: 0px 0px 10px 0px;
      // margin: auto;
    }
  }

  .poolDuration {
    color: ${(props) => props.theme.palette.card.text.primary};
    font-weight: 12px;
    margin-top: 2rem;
  }

  .sectionFooter {
    justify-content: space-between;
    margin-top: 1rem;
    a {
      color: ${(props) => props.theme.palette.text.primary};
      font-size: 1.2rem;
      margin-bottom: 0;
      text-decoration: underline;
    }
  }

  // @media (max-width: 600px) {
  //   .margin {
  //     margin: 0px 20px 10px 20px;
  //   }
  // }
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-radius: 2px;
  border: 0.5px solid ${(props) => props.theme.palette.common.border.dark};
  margin: 4px 0px;
  padding: 0.6rem 2rem;
  height: 20%;
  color: ${(props) => props.theme.palette.common.text.secondary};
  p {
    font-size: 10px;
    color: ${(props) => props.theme.palette.common.text.secondary};
    font-weight: 600;
    margin: 0px;
    a {
      color: ${(props) => props.theme.palette.common.text.secondary};
    }

    .key {
      margin-right: 10px;
    }
  }
`;
export const Timer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .colon {
    font-size: 1.6rem;
    margin: 0 1rem;
  }

  .date {
    padding: 10px;
    text-align: center;
    justify-content: center;
    flex-direction: column;
    width: 50px;
    height: 50px;
    background-color: ${(props) => props.theme.palette.common.mainBackground};
    color: ${(props) => props.theme.palette.common.text.primary};
    border-radius: 5px;
    position: relative;
    /* 
    &:not(:last-child){
        &::after{
            content: ":";
            position:absolute;
            top:50%;
            transform:translateY(-50%);
            font-size: 1.8rem;
            right:-2rem;
        }
    } */

    .value {
      font-weight: 600;
    }

    .unit {
      margin-bottom: 0;
    }

    .color {
      color: ${(props) => props.theme.palette.card.text.primary};
    }
  }
`;

export const Footer = styled.div`
  a {
    color: ${((props) => props.theme.palette.common.text.secondary, "50%")};
  }
`;
